import { createFileRoute } from "@tanstack/react-router"

import { priceRouteDataPreload } from "@/screens/Companies/products/PricingPackage/priceRouteDataPreload"
import { ProductPricingTerms } from "@/screens/Companies/products/PricingPackage/ProductPricingTerms"
import { selectProduct, selectSourceLocationId, useProductStore } from "@/stores/useProductStore"

export const Route = createFileRoute("/app/product/$productId/edit/_layout/pricing")({
  loader: priceRouteDataPreload,
  component: RouteComponent,
})

function RouteComponent() {
  const product = useProductStore(selectProduct)

  const sourceLocationId = useProductStore(selectSourceLocationId)

  if (!product) {
    return null
  }

  return <ProductPricingTerms product={product} sourceId={sourceLocationId ?? ""} />
}
